module.exports = __webpack_public_path__ + "img/9788949123233.2bb41671.jpg";